import React, { useState, Fragment } from "react";
import { FaBars, FaCaretLeft, FaSearchLocation, FaLocationArrow, FaClipboardList, FaFacebookSquare, FaCommentMedical } from "react-icons/fa";
import { SideButton, SideTitleDiv, SideDiv, SideImg, SideModal, OpenButton, CloseButton, DivContent } from "./styled/sidemenustyled";
import imgheader from './img/image_header.png'

// https://codesandbox.io/s/side-panel-toggle-example-xn4tj
// eslint-plugin-react-hooks 

const SideMenu = ({ locatePosition, getClosestLocation }) => {
    // SideMenu開關設定
    const [isOpen, setOpen] = useState(false);

    // 口‍罩供‍需資訊平‍台
    function triggerLink() {
        window.open('https://mask.pdis.nat.gov.tw/')
    }
    // 1922防疫達人
    function triggerFB() {
        window.open('https://www.facebook.com/TWCDC/')
    }
    // 武漢肺炎相關資訊
    function triggerCDCTW() {
        window.open('https://www.cdc.gov.tw/Disease/SubIndex/N6XvFa1YP9CXYdB0kNSA9A')
    }

    // LegendLink開關function
    function sideMenuClick() {
        setOpen(!isOpen);
    }

    return (
        <Fragment>
            {/* 這是SideMenu開關 */}
            <OpenButton onClick={sideMenuClick} >
                <FaBars />
            </OpenButton>
            {/* SideMenu、Modal */}
            <SideModal isOpen={isOpen} onClick={sideMenuClick} />
            <SideDiv isOpen={isOpen} >
                {isOpen ? (
                    <Fragment>
                        <SideTitleDiv className='sideTitle'><SideImg src={imgheader} alt='' />歡迎使用找口罩地圖</SideTitleDiv>
                        <br />
                        <DivContent className='sideHeader '>
                            <SideButton onClick={locatePosition} ><FaLocationArrow />我的位置</SideButton>
                            <SideButton value='adult' onClick={getClosestLocation}><FaSearchLocation />最近大人口罩</SideButton>
                            <SideButton value='child' onClick={getClosestLocation}><FaSearchLocation />最近幼兒口罩</SideButton>
                            <SideButton onClick={triggerLink}><FaClipboardList />口‍罩供‍需資訊平‍台</SideButton>
                            <SideButton onClick={triggerFB}><FaFacebookSquare />1922防疫達人</SideButton>
                            <SideButton onClick={triggerCDCTW}><FaCommentMedical />武漢肺炎相關資訊</SideButton>
                        </DivContent>
                        <CloseButton onClick={sideMenuClick}>
                            <FaCaretLeft />Close
                        </CloseButton>
                    </Fragment>
                ) : null}
            </SideDiv>
        </Fragment>
    );
};

export default SideMenu;
